export default __webpack_public_path__ + "static/media/Blade of the Bloodhunter.4165f655.jpg";